export function telespotAuthDataAccess(): string {
  return "telespot-auth-data-access";
}

export * from "./state";
